import { render, staticRenderFns } from "./default.vue?vue&type=template&id=28a0d7b0"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutFooter: require('/home/leodev/Sistemas/loja/components/Layout/Footer.vue').default,LayoutHeader: require('/home/leodev/Sistemas/loja/components/Layout/Header.vue').default,ButtonFloatWhatsapp: require('/home/leodev/Sistemas/loja/components/ButtonFloatWhatsapp.vue').default,PoliticaCookie: require('/home/leodev/Sistemas/loja/components/PoliticaCookie.vue').default})
